import { createReducer, on } from '@ngrx/store';
import { AssistantState } from './assistant.state';
import { assistantStateInitial } from './assistant.state.initial';
import { AssistantActions } from './assistant.actions';

/**
 * Reducer für das Assistent-Panel.
 *
 * Die Größe überlebt jedes Öffnen und Schließen: Sie ist eine Vorliebe des
 * Nutzers, keine Eigenschaft eines einzelnen Besuchs. Geändert wird sie nur
 * durch den Umschalter im Panel-Kopf oder durch den gemerkten Wert vom Start.
 */
export const assistantReducers = createReducer(
  assistantStateInitial,

  on(
    AssistantActions.toggle,
    (state): AssistantState => ({
      ...state,
      isOpen: !state.isOpen,
    }),
  ),

  on(
    AssistantActions.open,
    (state): AssistantState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    AssistantActions.close,
    (state): AssistantState => ({
      ...state,
      isOpen: false,
    }),
  ),

  on(
    AssistantActions.toggleSize,
    (state): AssistantState => ({
      ...state,
      size: state.size === 'small' ? 'large' : 'small',
    }),
  ),

  on(
    AssistantActions.restoreSize,
    (state, { size }): AssistantState => ({
      ...state,
      size,
    }),
  ),

  on(
    AssistantActions.reset,
    (state): AssistantState => ({
      ...assistantStateInitial,
      // INFO: Der Reset soll verhindern, dass das Panel beim Wiedereintritt
      // in den Standalone-Bereich ungefragt aufgeht - das betrifft die
      // Sichtbarkeit. Die gemerkte Größe bleibt, sonst wäre sie nach jedem
      // Verlassen des Bereichs wieder vergessen.
      size: state.size,
    }),
  ),
);
